interface Info {
  title: string;
  subtitle: string;
  icon: string;
  favorite?: boolean;
}
export interface EntityModel {
  entity_properties: {
    engine_brand: string;
    brand: string;
    model: string;
    type: string;
  };
  created_at: string;
  created_by: string;
  can_be_recovered: boolean;
  id: string;
  imei: number;
  name: string;
  odo: number;
  business: string;
  tags?: any;
}

export default function mkInfoData (entity: EntityModel, address: string, activity: string, translate: Function): Info[] {

  return [
    {
      icon: 'fal fa-street-view',
      title: translate({ s: 'sidebar.information.lastLocation', component: 'Map' }),
      subtitle: address || translate({ s: 'sidebar.information.noLastLocation', component: 'Map' })
    },
    {
      icon: 'fal fa-alarm-clock',
      subtitle: activity || translate({ s: 'sidebar.information.noLastActivity', component: 'Map' }),
      title: translate({ s: 'sidebar.information.lastActivity', component: 'Map' })
    },
    {
      icon: 'fal fa-digital-tachograph',
      subtitle: `${entity.odo || 0} km`,
      title: translate({ s: 'sidebar.information.odoDistance', component: 'Map' })
    },
    {
      icon: 'fal fa-stars',
      favorite: false,
      subtitle: entity?.entity_properties?.brand || translate({ s: 'sidebar.information.noBrand', component: 'Map' }),
      title: translate({ s: 'sidebar.information.brand', component: 'Map' })
    },
    {
      icon: 'fal fa-motorcycle',
      favorite: false,
      subtitle: entity?.entity_properties?.model || translate({ s: 'sidebar.information.noModel', component: 'Map' }),
      title: translate({ s: 'sidebar.information.model', component: 'Map' })
    },
    {
      icon: 'fal fa-battery-bolt',
      favorite: false,
      subtitle: entity?.entity_properties?.engine_brand || translate({ s: 'sidebar.information.noPowerUnit', component: 'Map' }),
      title: translate({ s: 'sidebar.information.powerUnit', component: 'Map' })
    },
    {
      icon: 'fal fa-bicycle',
      favorite: false,
      subtitle: entity?.entity_properties?.type ?? 'Unknown',
      title: translate({ s: 'sidebar.information.vehicleType', component: 'Map' })
    },
    {
      icon: 'fal fa-barcode-alt',
      favorite: false,
      subtitle: entity?.imei ?? '',
      title: translate({ s: 'sidebar.information.imei', component: 'Map' })
    },
    {
      icon: 'fal fa-id-card-alt',
      favorite: false,
      subtitle: entity ? entity.business : 'Not linked to vendor',
      title: translate({ s: 'sidebar.information.business', component: 'Map' })
    }
  ]
}
